// extracted by mini-css-extract-plugin
export default {"button-sso-google":"ButtonSSOGoogle_button-sso-google__dJPsS","signin-title":"ButtonSSOGoogle_signin-title__s6NwT"};